
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSwitch03On as ObiSwitch03OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-switch-03-on.js';
 
 
 

 
 export const ObiSwitch03On = createComponent({
   react: React,
   tagName: 'obi-switch-03-on',
   elementClass: ObiSwitch03OnElement,
   events: {
     
   }
  });
 
 